import { Component, HostBinding } from '@angular/core';

@Component({
  selector: 'kiosk-footer',
  template: require('./kiosk-footer.component.html'),
  styles: [require('./kiosk-footer.component.scss')],
  preserveWhitespaces: false,
})
export class KioskFooterComponent {
  @HostBinding('attr.role') role = 'contentinfo'; 
}



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/kiosk/kiosk-footer/kiosk-footer.component.ts